import {Keycode} from "../constants";

export default class Lightbox {
	constructor() {
		this._inputContent = null;

		this._lightbox = null;

		this._wrapper = null;

		this._content = null;

		this._lightboxHandler = null;

		this._scrollPosition = null;
	}

	open(content) {
		this._inputContent = typeof content === `string` ? content : content.outerHTML;
		this._removePreviousLightbox();
		this._rememberScrollPosition();
		this._showLightbox();
		this._setPageStyles();
	}

	close() {
		this._removeLightbox();
		this._removePageStyles();
		// this._clearHash();
		this._setScrollPosition();
	}

	getLightbox()
	{
		return this._lightbox;
	}
	
	addClasses(element, ...className)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.classList.add(...className);
		}
	}

	removeClasses(element, ...className)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.classList.remove(...className);
		}
	}

	addAttribute(element, attributeName, value)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.setAttribute(attributeName, value);
		}
	}

	removeAttribute(element, attributeName)
	{
		const node = this._getElementNode(element);

		if (node)
		{
			node.removeAttribute(attributeName);
		}
	}

	appendContent(content)
	{
		if (this._content)
		{
			this._inputContent += content;
			this._content.insertAdjacentHTML(`beforeend`, content);
		}
	}

	replaceContent(content)
	{
		if (this._content)
		{
			this._inputContent = content;
			this._content.innerHTML = this._inputContent;
		}
	}

	_getElementNode(value)
	{
		return value === `lightbox` ? this._lightbox : value === `wrapper` ? this._wrapper : this._content;
	}

	_showLightbox()
	{
		this._createLightbox();
		this._setLightboxHandlers();
	}

	_createLightbox()
	{
		this._lightbox = document.createElement(`div`);
		this._lightbox.classList.add(`lightbox`);
		this._createContent();
		this._lightbox.appendChild(this._wrapper);
		document.body.appendChild(this._lightbox);
	}

	_createContent()
	{
		this._wrapper = document.createElement(`div`);
		this._wrapper.classList.add(`wrapper`);
		this._createCloseButton();

		this._content = document.createElement(`div`);
		this._content.classList.add(`content`);
		this._content.innerHTML = this._inputContent;

		this._wrapper.appendChild(this._content);
	}

	_createCloseButton()
	{
		const closeButton = document.createElement(`button`);
		closeButton.type = `button`;
		closeButton.classList.add(`close`);
		closeButton.textContent = `Закрыть`;
		this._wrapper.prepend(closeButton);
	}

	_setLightboxHandlers()
	{
		const action = this.close.bind(this);

		const makeCloseLightbox = () => ((evt) => {
			if (
				evt.keyCode === Keycode.ESC
				||
				( evt.target.tagName.toLowerCase() === `button` && evt.target.classList.contains(`close`) )
				||
				( evt.target.tagName.toLowerCase() === `div` && evt.target.classList.contains( `lightbox` ) )
			) {
				action();
			}
		});

		this._lightboxHandler = makeCloseLightbox();

		document.addEventListener(`keyup`, this._lightboxHandler);
		document.addEventListener(`click`, this._lightboxHandler);
	}

	_removeLightboxHandlers()
	{
		document.removeEventListener(`keyup`, this._lightboxHandler);
		document.removeEventListener(`click`, this._lightboxHandler);
		this._lightboxHandler = null;
	}

	_setPageStyles()
	{
		document.documentElement.style.paddingRight = `${this._getScrollWidth()}px`;
		document.documentElement.style.overflow = `hidden`;
		document.body.style.overflow = `hidden`;
	}

	_removePageStyles()
	{
		document.documentElement.style.paddingRight = ``;
		document.documentElement.style.overflow = ``;
		document.body.style.overflow = ``;
	}

	_getScrollWidth()
	{
		return window.innerWidth - document.body.clientWidth;
	}

	_rememberScrollPosition()
	{
		this._scrollPosition = [window.pageXOffset, window.pageYOffset];
	}

	_removePreviousLightbox()
	{
		const previousLightbox = document.querySelector(`div.lightbox`);

		previousLightbox ? previousLightbox.remove() : false;
	}

	_clearHash()
	{
		location.hash = ``;
	}

	_setScrollPosition()
	{
		window.scrollTo(...this._scrollPosition);
		this._scrollPosition = null;
	}

	_removeLightbox()
	{
		this._lightbox.remove();
		this._inputContent = null;
		this._lightbox = null;
		this._contentOutput = null;
		this._wrapper = null;
		this._content= null;
		this._removeLightboxHandlers();
	}
}
